"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// src/jsx/Google.tsx
function Google(props) {
  return /* @__PURE__ */ React__namespace.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ...props
  }, /* @__PURE__ */ React__namespace.createElement("path", {
    fillRule: "evenodd",
    d: "M12 4a8 8 0 108 8h-6v1h3.125a1 1 0 01.931 1.364A6.502 6.502 0 015.5 12a6.5 6.5 0 019.257-5.888l.978-1.188A7.961 7.961 0 0012 4zM2 12C2 6.477 6.477 2 12 2c2.168 0 4.177.69 5.816 1.864a1 1 0 01.19 1.45l-2.234 2.711a1 1 0 01-1.318.202 4.5 4.5 0 10.9 6.773H13a1 1 0 01-1-1v-3a1 1 0 011-1h8a1 1 0 011 1v1c0 5.523-4.477 10-10 10S2 17.523 2 12z",
    clipRule: "evenodd"
  }));
}
var Google_default = Google;

exports.Google_default = Google_default;
